<template>
  <div>
    <SectionHeader
      :logo="BusinessStudioLogo"
      productName="Business Studio+"
      :title="$t('tbs_home_plus__promo')"
      :subtext="$t('tbs_home_plus_promo_subtext')"
    />
    <div class="tw:mb-6">
      <StudioPlusProductsInfo />
    </div>
    <div class="tw:flex tw:flex-col tw:md:flex-row tw:justify-between">
      <div class="tw:md:mb-0 tw:mb-4">
        <p class="tw:text-2xl tw:font-bold" v-if="!isLoading">
          {{ formatCurrency(price) }}
        </p>
        <SmallDotLoader v-else color="#B4183A" />
        <p class="tw:text-xs tw:text-gray-700">
          {{ $t('check_out_billing_info_subscription')
          }}<span class="tw:ml-1">{{ $t('tbs_home_plus_tax_disclaimer') }}</span>
        </p>
      </div>
      <div class="tw:flex tw:flex-col tw:md:flex-row tw:gap-x-2.5">
        <GhostButton
          class="icon-btn tw:flex tw:gap-x-2 tw:items-center tw:justify-center tw:mb-4 tw:md:mb-0"
          @click="openVideo"
        >
          <PlayIcon class="tw:fill-gray-800" />
          {{ $t('promo_video_cta') }}
        </GhostButton>
        <MainButton @click="upgradeToPlus">{{
          hasAdminOrSupport ? $t('business_studio_plus_upgrade_cta') : $t('rc_admin_log_in_cta')
        }}</MainButton>
      </div>
    </div>
  </div>
</template>
<script setup>
import { computed } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'

import SectionHeader from '@/components/homePage/SectionHeader.vue'
import StudioPlusProductsInfo from '@/components/homePage/studioPlus/StudioPlusProductsInfo.vue'
import SmallDotLoader from '@/components/base/loaders/SmallDotLoader.vue'
import MainButton from '@/components/base/buttons/MainButton.vue'
import GhostButton from '@/components/base/buttons/GhostButton.vue'
import PlayIcon from '@/components/icons/PlayIcon.svg?component'

import { useStudioPlusPrice } from '@/components/payment/queries'
import { selectedAccommodationId } from '@/layouts/queries'
import { useSessionValues } from '@/composables/useSessionValues'
import { useFormatting } from '@/composables/useFormatting'

import appAnalytics from '@/utils/tracking'

const store = useStore()
const router = useRouter()
const BusinessStudioLogo = new URL('/src/assets/img/landing/landing_studio_plus.svg', import.meta.url)

const emit = defineEmits(['openVideo'])
const openVideo = () => emit('openVideo')
const { currency, hasAdminOrSupport } = useSessionValues()
const { formatCurrency } = useFormatting()
const { studioPlusPrice, isLoading } = useStudioPlusPrice({ selectedAccommodationId, currency })
const price = computed(() => studioPlusPrice.value?.baseSubscriptionMonthlyPrice ?? 0)

const upgradeToPlus = () => {
  if (hasAdminOrSupport.value) {
    appAnalytics.track(appAnalytics.events.HOMEPAGE_PLUS_UPGRADE_NOW, {
      accommodationId: selectedAccommodationId.value,
    })
    router.push({ name: 'studio-plus-payment' })
  } else {
    appAnalytics.track(appAnalytics.events.SP_HOMEPAGE_PLUS_LOGIN_AS_ADMIN_BTN_CLICKED, {
      accommodationId: selectedAccommodationId.value,
    })
    store.dispatch('session/logout', '/studio-plus/payment?loginAsAdmin=true')
  }
}
</script>
<style scoped>
.icon-btn:hover svg {
  fill: white;
}
</style>
